import { useEffect, useState } from 'react';
import { UpdateChatbotStateOptions } from '../endion-chatbot';
import { ENDION_CHATBOT_UPDATE_STATE_EVENT_NAME } from '../utils/events';

/**
 * Hook to manage chatbot open/close state with external control support
 * Listens for external events to control the chatbot state via window.endion.updateChatbotState()
 * Only responds to explicit boolean values for isOpen - no toggle functionality
 */
export function useChatOpenState() {
  const [isOpen, setIsOpen] = useState(false);

  // Listen for external chatbot state changes
  useEffect(() => {
    const handleToggleState = (event: Event) => {
      const customEvent = event as CustomEvent<UpdateChatbotStateOptions>;
      const { isOpen: externalIsOpen } = customEvent.detail;

      if (typeof externalIsOpen === 'boolean') {
        setIsOpen(externalIsOpen);
      }
      // If isOpen is undefined, do nothing (no toggle functionality)
    };

    document.addEventListener(ENDION_CHATBOT_UPDATE_STATE_EVENT_NAME, handleToggleState);

    return () => {
      document.removeEventListener(ENDION_CHATBOT_UPDATE_STATE_EVENT_NAME, handleToggleState);
    };
  }, []);

  return {
    isOpen,
    setIsOpen,
  };
}
